import React, { useEffect, useState, useRef } from "react";
import { UserNav } from "./user-nav";
import { SheetMenu } from "./sheet-menu";
import { useSelector } from "react-redux";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { CreditCard, Users, CheckCircle, Loader2 } from "lucide-react";
import SubscriptionService from "../../services/subscription/subscription";
import IndividualSubscriptionService from "../../services/subscription/individualSubscription";
import { toastError, toastSuccess } from "../ToastNotification";
import Organizationpopup from "../popup/Organizationpopup";
import IndividualPopup from "../popup/IndividualPopup";
// import { ModeToggle } from "../mode-toggle";

export function Navbar({ title }) {
  const user = useSelector((state) => state.superAdmin.user);
  const [userCount, setUserCount] = useState(5);
  const [loading, setLoading] = useState(false);
  const [subscriptionData, setSubscriptionData] = useState(null);

  const getActiveSubscription = async () => {
    try {
      let response;
      if (user.admintype === "OrganizationAdmin") {
        response = await SubscriptionService?.getSubscription();
      } else if (user.admintype === "IndividualAdmin") {
        response = await IndividualSubscriptionService?.getSubscription();
      }
      if (response?.data?.success) {
        setSubscriptionData(response?.data?.data?.active_subscription);
      }
    } catch (error) {
      console.log("🚀  getActiveSubscription  error:", error);
    }
  };

  useEffect(() => {
    if (
      user?.admintype === "Admin" ||
      user?.admintype === "OrganizationAdmin" ||
      user?.admintype === "IndividualAdmin"
    ) {
      getActiveSubscription();
    } else {
      setSubscriptionData(null);
    }
  }, [user?.admintype, user?._id, user?.email]);


  const handleCreateSubscription = async () => {
    try {
      setLoading(true);
      const response = await SubscriptionService?.createSubscription({
        requested_seats: userCount,
      });

      console.log("🚀  handleCreateSubscription  response:", response?.data);

      if (response?.data?.success && response?.data?.data?.checkout_url) {
        window.location.href = response.data.data.checkout_url;
      }
    } catch (error) {
      console.log("🚀  handleCreateSubscription  error:", error);
      toastError(error?.response?.data?.message || "Failed to create subscription");
    } finally {
      setLoading(false);
    }
  };

  const handleCancelSubscription = async () => {
    if (window.confirm("Are you sure you want to cancel your subscription? This action cannot be undone.")) {
      try {
        setLoading(true);
        const response = await SubscriptionService?.cancelSubscription();
        if (response?.data?.success) {
          toastSuccess(response?.data?.message || "Subscription cancelled successfully");
          getActiveSubscription();
        }
      } catch (error) {
        console.log("🚀  handleCancelSubscription  error:", error);
        toastError(error?.response?.data?.message || "Failed to cancel subscription");
      } finally {
        setLoading(false);
      }
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  console.log("navbar user", user);
  return (
    <header className="sticky top-0 z-10 w-full bg-sidebar shadow backdrop-blur border-b border-border">
      <div className="mx-4 sm:mx-8 flex h-14 items-center">
        <div className="flex items-center space-x-4 lg:space-x-0 ">
          <SheetMenu />
          <h1 className="font-bold">{title}</h1>
        </div>
        <div className="flex flex-1 items-center space-x-2 justify-between">
          <div className="ml-5 md:ml-10">
            {user?.admintype === "OrganizationAdmin" && (
              <div>
                Organization
              </div>
            )}
            {user?.admintype === "IndividualAdmin" && (
              <div>
                Individual
              </div>
            )}
          </div>
          <div className="flex justify-between items-center gap-2">







            {(user?.admintype === "Admin" || user?.admintype === "OrganizationAdmin" || user?.admintype === "IndividualAdmin") && (
              // <Dialog>
              //   <DialogTrigger asChild>
              //     <Button
              //       variant="outline"
              //       className="flex gap-2 bg-transparent border-primary text-primary hover:bg-primary hover:text-white"
              //     >
              //       <CreditCard className="w-4 h-4" />
              //       {subscriptionData ? "Manage Subscription" : "Subscription"}
              //     </Button>
              //   </DialogTrigger>
              //   <DialogContent className="sm:max-w-[450px] bg-[#070710] text-white border-white/20">
              //     <DialogHeader>
              //       <DialogTitle className="text-white flex items-center gap-2">
              //         <Users className="w-5 h-5 text-primary" />
              //         Team Subscription
              //       </DialogTitle>
              //     </DialogHeader>
              //     <div className="grid gap-4 py-4">
              //       <div className="flex flex-col gap-4">
              //         <div className="flex flex-col gap-1 items-center justify-center py-4 bg-white/5 rounded-lg border border-white/10">
              //           <span className="text-3xl font-bold text-primary">
              //             $300
              //           </span>
              //           <span className="text-gray-400 text-sm">
              //             + team size pricing
              //           </span>
              //         </div>

              //         <div className="grid gap-2">
              //           <Label htmlFor="user-count" className="text-gray-300">
              //             Number of Users
              //           </Label>
              //           <Input
              //             id="user-count"
              //             type="number"
              //             min="5"
              //             value={userCount}
              //             onChange={(e) => setUserCount(e.target.value)}
              //             className="bg-white/5 border-white/10 text-white"
              //           />
              //         </div>

              //         <div className="space-y-3">
              //           <h4 className="text-sm font-semibold text-gray-300">
              //             Key Features:
              //           </h4>
              //           <ul className="space-y-2">
              //             {[
              //               "Subscription based on number of users",
              //               "Team size: 5-100 users Price: $10 Per User",
              //               "Team size: 101-500 users Price: $8 Per User",
              //               "Team size: 501-1000 users Price: $6 Per User",
              //               "Admin panel for team management",
              //               "Upload documents accessible to all team members",
              //               "Automatic upgrade prompts when team grows",
              //             ].map((feature, index) => (
              //               <li
              //                 key={index}
              //                 className="flex items-start gap-2 text-sm text-gray-400"
              //               >
              //                 <CheckCircle className="w-4 h-4 text-primary shrink-0 mt-0.5" />
              //                 {feature}
              //               </li>
              //             ))}
              //           </ul>
              //         </div>
              //       </div>
              //     </div>

              //     {subscriptionData ? (
              //       <div className="bg-primary/10 border border-primary/20 rounded-lg p-4 mb-4">
              //         <div className="flex items-center gap-2 text-primary mb-2">
              //           <CheckCircle className="w-5 h-5" />
              //           <span className="font-semibold text-lg">Active Subscription</span>
              //         </div>
              //         <div className="space-y-1 text-sm text-gray-400">
              //           <div className="flex justify-between">
              //             <span>Seats:</span>
              //             <span className="text-white font-medium">{subscriptionData.purchased_seats}</span>
              //           </div>
              //           <div className="flex justify-between">
              //             <span>{subscriptionData.cancel_at_period_end ? " Expiry Date: " : " Renewal Date: "}</span>
              //             <span className="text-white font-medium">{formatDate(subscriptionData.current_period_end)}</span>
              //           </div>
              //         </div>

              //         {!subscriptionData.cancel_at_period_end && (
              //           <Button
              //             variant="destructive"
              //             onClick={handleCancelSubscription}
              //             className="w-full mt-4 bg-red-600/20 text-red-500 border border-red-500/50 hover:bg-red-600 hover:text-white transition-all duration-300"
              //             disabled={loading}
              //           >
              //             {loading ? (
              //               <>
              //                 <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              //                 Cancelling...
              //               </>
              //             ) : (
              //               "Cancel Subscription"
              //             )}
              //           </Button>
              //         )}


              //       </div>
              //     ) : (
              //       <Button
              //         onClick={handleCreateSubscription}
              //         className="w-full bg-primary hover:bg-btnHover text-white border-0 py-6 text-lg"
              //         disabled={loading}
              //       >
              //         {loading ? (
              //           <>
              //             <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              //             Please wait
              //           </>
              //         ) : (
              //           "Get Started"
              //         )}
              //       </Button>
              //     )}
              //   </DialogContent>
              // </Dialog>
              <>
                {(user?.admintype === "Admin" || user?.admintype === "OrganizationAdmin") && (
                  <Organizationpopup />
                )}
                {user?.admintype === "IndividualAdmin" && (
                  <IndividualPopup />
                )}
              </>
            )}

            {/* <ModeToggle /> */}
            <UserNav />

          </div>
        </div>
      </div>
    </header>
  );
}
